<template>
	<div class="dropdown-container" ref="dropdown">
		<!-- Custom Select -->
		<div class="dropdown-toggle" @click="toggleDropdown">
			<div class="dropdown-selected">
				<img v-if="selectedOption && selectedOption.logo" :src="selectedOption.logo" alt="Logo"
					class="dropdown-logo ml-3" />
				<span class="text-xs p-3">{{ selectedOption ? selectedOption.label : placeholderProp }}</span>
			</div>

			<span class="px-3">
				<IconArrow />
			</span>
		</div>

		<!-- Dropdown Options -->
		<div v-if="dropdownVisible" class="dropdown-options shadow-lg">
			<div v-for="option in options" :key="option.value" class="dropdown-option" @click="selectOption(option)">
				<div v-if="isLogo">
					<img :src="option.logo" alt="Logo" class="dropdown-logo" />
				</div>
				<div>
					<div class="text-xs font-medium">{{ option.label }}</div>
					<div v-if="isSubLabel" class="text-xs mt-1">{{ option.subLabel || null }}</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import { is } from 'core-js/core/object'
import IconArrow from '../icons/IconArrow.vue'

export default {
	name: 'Select',

	components: {
		IconArrow,
	},

	props: {
		// [
		// 	{
		// 		value: "apple",
		// 		label: "Apple",
		// 		subLabel: "ASDF",
		// 		logo: "https://upload.wikimedia.org/wikipedia/commons/f/fa/Apple_logo_black.svg",
		// 	},
		// ]
		options: {
			type: Array,
			required: true,
		},

		placeholderProp: {
			type: String,
			default: "Select an option",
		},

		isLogo: {
			type: Boolean,
			default: true,
		},

		isSubLabel: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			selectedOption: null,
			dropdownVisible: false,
		}
	},
	methods: {
		toggleDropdown() {
			this.dropdownVisible = !this.dropdownVisible
		},
		selectOption(option) {
			this.selectedOption = option
			this.dropdownVisible = false
			this.$emit("input", option)
		},
		handleClickOutside(event) {
			if (!this.$refs.dropdown.contains(event.target)) {
				this.dropdownVisible = false
			}
		},
	},
	mounted() {
		document.addEventListener("click", this.handleClickOutside)
	},
	beforeDestroy() {
		document.removeEventListener("click", this.handleClickOutside)
	},
}
</script>


<style scoped>
.dropdown-container {
	position: relative;
	width: fit-content;
	font-family: Arial, sans-serif;
}

.dropdown-toggle {
	display: flex;
	justify-content: space-between;
	align-items: center;
	/* padding: 10px; */
	/* border: 1px solid #ccc; */
	border-radius: 0.375rem;
	background-color: var(--grey-1-color);
	cursor: pointer;
}

.dropdown-selected {
	display: flex;
	align-items: center;
	/* gap: 10px; */
}

.dropdown-arrow {
	font-size: 0.75rem;
	color: #666;
}

.dropdown-logo {
	width: 1.25rem;
	height: 1.25rem;
	border-radius: 0.1875rem;
}

.dropdown-options {
	position: absolute;
	top: 105%;
	left: 0;
	width: 100%;
	/* border: 1px solid #ccc; */
	border-radius: 0 0 0.25em 0.25em;
	background-color: var(--grey-1-color);
	z-index: 1000;
}


.dropdown-option {
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px;
	border-bottom: solid 1px var(--grey-4-color);
	cursor: pointer;
	/* transition: background-color 0.2s ease-in-out; */
}

.dropdown-option:first-child {
	border-top-left-radius: 0;
	border-top-right-radius: 0;
}

.dropdown-option:last-child {
	border-bottom: none;
}

.dropdown-option:hover {
	background-color: var(--grey-4-color);
}
</style>
